import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import {
    TemplatedDialogComponent,
    TemplatedDialogConfig,
    TemplatedDialogResult
} from '@shared/components/templated-dialog';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class DialogService {
    openDialogs: MatDialogRef<any>[] = [];

    constructor(private dialog: MatDialog) {}

    openDialog(data: TemplatedDialogConfig, options?: MatDialogConfig): Observable<TemplatedDialogResult> {
        const ref = this.dialog.open(TemplatedDialogComponent, {
            position: { top: '50px' },
            width: data.width || '600px',
            panelClass: 'custom-dialog',
            closeOnNavigation: true,
            disableClose: true,
            data,
            ...options
        });
        ref.afterClosed().subscribe(e => (this.openDialogs = this.openDialogs.filter(d => d !== e)));
        this.openDialogs.push(ref);
        return ref.beforeClosed();
    }

    closeAllDialogs() {
        this.openDialogs.forEach(e => e.close());
    }

    deleteDialog(): Promise<boolean> {
        return this.openDialog({
            title: 'dialog.generic.deleteQuestion',
            message: 'dialog.generic.deleteQuestionDesc',
            sureQuestion: true
        })
            .toPromise()
            .then(e => e?.result ?? false);
    }
}
